export default __webpack_public_path__ + "static/hightlight-product-bg-462a02d971ff1883e3b37c6bd1f9bf3f.jpg";